import { render } from "./BaseDatePickerCompact.vue?vue&type=template&id=865da4e2&scoped=true"
import script from "./BaseDatePickerCompact.vue?vue&type=script&lang=js"
export * from "./BaseDatePickerCompact.vue?vue&type=script&lang=js"

import "./BaseDatePickerCompact.vue?vue&type=style&index=0&id=865da4e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-865da4e2"]])

export default __exports__